import {VehicleDTO} from './Vehicle/vehicleDTO.interface';
import {StatusDTO} from './statusDTO.interface';
import {AdvertDTO} from "./advertDTO.interface";
import {BaseDTO} from "./_baseDTO.interface";
import {BaseIntDTO} from "./_baseIntDTO.interface";

export interface CountryDTO extends BaseIntDTO {
  countryName?: string;
}
